/* eslint-disable @typescript-eslint/no-unsafe-argument */
import React, { useCallback } from "react";
import { ApiResponse } from "~/api/GeneratedApi";
import { useAxios } from "~/utils/hooks/useAxios";
import { useCustomMutation } from "~/utils/hooks/useCustomMutation";

interface Props {
  onSuccess?: () => void;
}

interface UploadFileProps {
  parentNodeId: number;
  data: FormData;
}

// interface ReturnProps {
//   uploadProgress?: number;
//   uploadFiles: (parentNodeId: number, files: File[]) => Promise<ApiResponse[]>;
// }

export const useFileUpload = (props?: Props) => {
  const axios = useAxios();
  const [filesState, setFilesState] = React.useState<File[]>([]);

  const [uploadProgress, setUploadProgress] = React.useState<number>();

  const { mutateAsync: upload } = useCustomMutation<
    ApiResponse,
    ApiResponse,
    UploadFileProps
  >(
    ({ parentNodeId, data }: UploadFileProps) =>
      new Promise((resolve, reject) => {
        axios
          .post<ApiResponse>(`/api/File/${parentNodeId}`, data, {
            onUploadProgress: (progressEvent: ProgressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
              setUploadProgress(percentCompleted);
            },
          })
          .then((x) => resolve(JSON.parse(x.data as string)))
          .catch((err) => reject(err));
      }),
    {
      onSuccess: () => {
        setUploadProgress(undefined);
        props?.onSuccess?.();
      },
    },
  );

  // const uploadFilesProgress = useCallback(
  //   async (parentNodeId: number, files: File[], projection: string) => {
  //     const promises = await Promise.all(
  //       files.map((x) => uploadFileProgress(parentNodeId, x, projection)),
  //     );
  //     return promises;
  //   },
  //   [uploadFileProgress],
  // );

  const uploadFile = useCallback(
    async (parentNodeId: number, file: File) => {
      const data = new FormData();
      data.append("file", file);
      const res = await upload({ parentNodeId, data });
      return res;
    },
    [upload],
  );

  const uploadFiles = useCallback(
    async (parentNodeId: number, files: File[]) => {
      const promises = await Promise.all(
        files.map((x) => uploadFile(parentNodeId, x)),
      );
      return promises;
    },
    [uploadFile],
  );

  return {
    uploadProgress,
    uploadFiles,
    filesState,
    setFilesState,
  };
};
